<template>
  <main class="page-main support">
    <!-- 국문 -->
    <template v-if="locale === 'ko'">
      <section class="page-heading-wrap">
        <h3 class="page-heading">{{ $t('question.title') }}</h3>
        <html-view :value="$t('question.copy')" tag="p" class="page-heading-desc" />
      </section>

      <partnership />
    </template>

    <!-- 영문 -->
    <template v-else-if="locale === 'en'">
      <section class="page-heading-wrap">
        <h3 class="page-heading">{{ $t('question.title') }}</h3>
      </section>
      <section class="support-center">
        <p class="description">
          {{ $t('question.center.description') }}
        </p>
        <ul class="tel">
          <html-view tag="li" :value="$t('question.center.list[0]')" />
          <html-view tag="li" :value="$t('question.center.list[1]')" />
        </ul>
      </section>
    </template>

    <!--<tab :tab-list="tabList" />
    <router-view />-->
  </main>
</template>
<script>
import { mapGetters } from 'vuex'
// import defendPath from '@/mixins/defendPath'

export default {
  components: {
    Partnership: () => import('@/views/question/Partnership'),
    // tab: () => import('@/components/base/Tab'),
  },
  // mixins: [defendPath],
  data () {
    return {
      word: '',
      tabList: [
        // { path: 'questionPartnership', name: 'question.tabPartnerships' },
        // { path: 'questionPress', name: 'question.tabMedia' },
        // { path: 'questionCulture', name: 'question.tabCulture' },
        // { path: 'questionOther', name: 'question.tabOther' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale/GET_LOCALE',
    })
  },
}
</script>
